import { Menu } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';

import UilEllipsisV from '@iconscout/react-unicons/icons/uil-ellipsis-v';
import UilCreateDashboard from '@iconscout/react-unicons/icons/uil-create-dashboard';
import { GoHome } from 'react-icons/go';
import { IoAnalyticsOutline } from 'react-icons/io5';
import propTypes from 'prop-types';

function MenuItems({ toggleCollapsed }) {
  const { t } = useTranslation();

  function getItem(label, key, icon, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  }

  const { topMenu } = useSelector((state) => {
    return {
      topMenu: state.ChangeLayoutMode.topMenu,
    };
  });

  const path = '/admin';

  const pathName = window.location.pathname;
  const pathArray = pathName.split(path);
  const mainPath = pathArray[1];
  const mainPathSplit = mainPath.split('/');

  const [openKeys, setOpenKeys] = React.useState(
    !topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : [],
  );

  const onOpenChange = (keys) => {
    setOpenKeys(keys[keys.length - 1] !== 'recharts' ? [keys.length && keys[keys.length - 1]] : keys);
  };

  const onClick = (item) => {
    if (item.keyPath.length === 1) setOpenKeys([]);
  };

  const items = [
    getItem(
      <NavLink onClick={toggleCollapsed} to={`${path}/pages/starter`}>
        {t('Home')}
      </NavLink>,
      'starter',
      !topMenu && (
        <NavLink className="menuItem-iocn" to={`${path}/pages/starter`}>
          <GoHome />
        </NavLink>
      ),
    ),
    getItem(
      <NavLink onClick={toggleCollapsed} to={`${path}/analytics/all`}>
        {t('Analytics')}
      </NavLink>,
      'analytics',
      !topMenu && (
        <NavLink className="menuItem-iocn" to={`${path}/analytics/all`}>
          <IoAnalyticsOutline />
        </NavLink>
      ),
    ),
    getItem(t('FarmHub'), 'FarmHub Menu', !topMenu && <UilCreateDashboard />, [
      getItem(
        <NavLink onClick={toggleCollapsed} to={`${path}/farmhub/add`}>
          {t('FarmHub Registration')}
        </NavLink>, // Menu Title
        '11', // Menu ID
      ),
      getItem(
        <NavLink onClick={toggleCollapsed} to={`${path}/farmhub/list`}>
          {t('FarmHub List')}
        </NavLink>, // Menu Title
        '12', // Menu ID
      ),
    ]),
    getItem(t('Farmers'), 'Farmers Menu', !topMenu && <UilCreateDashboard />, [
      getItem(
        <NavLink onClick={toggleCollapsed} to={`${path}/farmer/registration`}>
          {t('Farmers Registration')}
        </NavLink>, // Menu Title
        '1', // Menu ID
      ),
      getItem(
        <NavLink onClick={toggleCollapsed} to={`${path}/farmer/list`}>
          {t('Farmers List')}
        </NavLink>, // Menu Title
        '2', // Menu ID
      ),
    ]),
    getItem(t('Farm'), 'Farm Menu', !topMenu && <UilCreateDashboard />, [
      getItem(
        <NavLink onClick={toggleCollapsed} to={`${path}/farm/registration`}>
          {t('Farm Registration')}
        </NavLink>, // Menu Title
        '4', // Menu ID
      ),

      getItem(
        <NavLink onClick={toggleCollapsed} to={`${path}/farm/list`}>
          {t('Farm List')}
        </NavLink>, // Menu Title
        '5', // Menu ID
      ),
    ]),
    getItem(t('Stock'), 'Stock Menu', !topMenu && <UilCreateDashboard />, [
      // getItem(
      //   <NavLink onClick={toggleCollapsed} to={`${path}/stock/add`}>
      //     {t('Stock Registration')}
      //   </NavLink>, // Menu Title
      //   '51', // Menu ID
      // ),
      getItem(
        <NavLink onClick={toggleCollapsed} to={`${path}/stock/list`}>
          {t('Stock List')}
        </NavLink>, // Menu Title
        '52', // Menu ID
      ),
    ]),
    getItem(t('Batch'), 'Batch Menu', !topMenu && <UilCreateDashboard />, [
      getItem(
        <NavLink onClick={toggleCollapsed} to={`${path}/batch/add`}>
          {t('Batch Registration')}
        </NavLink>, // Menu Title
        '61', // Menu ID
      ),
      getItem(
        <NavLink onClick={toggleCollapsed} to={`${path}/batch/list`}>
          {t('Batch List')}
        </NavLink>, // Menu Title
        '62', // Menu ID
      ),
    ]),
    getItem(t('Finances'), 'Finances Menu', !topMenu && <UilCreateDashboard />, [
      getItem(
        <NavLink onClick={toggleCollapsed} to={`${path}/finances/list`}>
          {t('Wallet List')}
        </NavLink>, // Menu Title
        '71', // Menu ID
      ),
    ]),
  ];

  return (
    <Menu
      onOpenChange={onOpenChange}
      onClick={onClick}
      mode={!topMenu || window.innerWidth <= 991 ? 'inline' : 'horizontal'}
      // // eslint-disable-next-line no-nested-ternary
      defaultSelectedKeys={
        !topMenu
          ? [
              `${
                mainPathSplit.length === 1 ? 'home' : mainPathSplit.length === 2 ? mainPathSplit[1] : mainPathSplit[2]
              }`,
            ]
          : []
      }
      defaultOpenKeys={!topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : []}
      overflowedIndicator={<UilEllipsisV />}
      openKeys={openKeys}
      items={items}
    />
  );
}

MenuItems.propTypes = {
  toggleCollapsed: propTypes.func,
};

export default MenuItems;
